import { render, staticRenderFns } from "./SupportTable.vue?vue&type=template&id=e52c30b4"
import script from "./SupportTable.vue?vue&type=script&lang=js"
export * from "./SupportTable.vue?vue&type=script&lang=js"
import style0 from "./SupportTable.vue?vue&type=style&index=0&id=e52c30b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports